import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid, Edit,
  List,
  Show,
  SimpleForm, SimpleShowLayout,
  TextField,
  TextInput,
  required, FunctionField,
  NumberInput,
  minValue,
  maxValue,
  number,
  ValidationErrorMessage, Filter, NullableBooleanInput
} from "react-admin";
import * as React from "react";
import {Typography} from "@material-ui/core";

function getUpdatedCreditString(input: number | null) {
  return input === 0 || input === null ? "" : " (" + input + " from the next month)"
}

const integerValidation = (value: number) => {
  const error: ValidationErrorMessage = 'Must be an integer'
  if (!Number.isInteger(value)) {
    return error;
  }
  return null;
};

export function CustomersList(props: any) {

  return (
    <List {...props} filters={<CustomerFilter/>} sort={{field: 'companyName', order: 'ASC'}}>
      <Datagrid rowClick="show">
        <TextField source="companyName"/>
        <BooleanField source="isActive"/>
        <TextField source="comments"/>
        <TextField source="address.country" label="Country"/>
        <TextField source="maxConcurrentSessions"/>
        <FunctionField
          source="creditsPerMonth"
          label="Credits Per Month"
          render={(record: any) => record.creditsPerMonth.toString() + getUpdatedCreditString(record.updatedCreditsForNextMonth)
          }/>
        <TextField source="additionalCreditsForThisMonth"/>
        <FunctionField
          source="creditsPerMonth"
          label="Credits Left This Month"
          sortable={false}
          render={(record: any) => {
            return +(record.creditsPerMonth + record.additionalCreditsForThisMonth - record.usedCreditsThisMonth).toFixed(2)
          }}/>
        <TextField source="hoursForecast" sortable={false}/>
      </Datagrid>
    </List>
  )
}

export const CustomerCreate = (props: any) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="companyName" validate={[required()]}/>
      <BooleanInput source="isActive" defaultValue={true}/>
      <TextInput source="comments"/>
      <Typography variant="h6" gutterBottom>Address</Typography>
      <TextInput source="address.country" label="Country"/>
      <TextInput source="address.region" label="Region" />
      <TextInput source="address.street" label="Street" />
      <TextInput source="address.houseNumber" label="House"/>
      <TextInput source="address.postalCode" label="Postal Code"/>
      <Typography variant="h6" gutterBottom>Credits and Sessions</Typography>
      <NumberInput
        source="maxConcurrentSessions"
        validate={[required(), number(), minValue(1), maxValue(10), integerValidation]}
        initialValue={5}
        step="1"
      />
      <NumberInput source="additionalCreditsForThisMonth" />
      <NumberInput source="creditsPerMonth" initialValue={700} validate={[required()]}/>
    </SimpleForm>
  </Create>
);

export const CustomerShow = (props: any) => (
  <Show title="Customer details" {...props} >
    <SimpleShowLayout>
      <TextField source="companyName"/>
      <BooleanField source="isActive"/>
      <TextField source="comments"/>
      <Typography variant="h6" gutterBottom>Address</Typography>
      <TextField source="address.country" label="Country"/>
      <TextField source="address.region" label="Region"/>
      <TextField source="address.street" label="Street"/>
      <TextField source="address.houseNumber" label="House"/>
      <TextField source="address.postalCode" label="Postal Code"/>
      <Typography variant="h6" gutterBottom>Credits and Sessions</Typography>
      <TextField source="maxConcurrentSessions"/>
      <FunctionField
        source="creditsPerMonth"
        label="Credits Per Month"
        render={(record: any) => record.creditsPerMonth.toString() + getUpdatedCreditString(record.updatedCreditsForNextMonth)
        }/>
      <TextField source="additionalCreditsForThisMonth"/>
      <FunctionField
        source="creditsPerMonth"
        label="Credits Left This Month"
        render={(record: any) => {
          return record.creditsPerMonth + record.additionalCreditsForThisMonth - record.usedCreditsThisMonth
        }}/>
      <TextField source="hoursForecast"/>
    </SimpleShowLayout>
  </Show>
);

export const CustomerEdit = (props: any) => (
  <Edit title="Edit customer" {...props}>
    <SimpleForm>
      <TextInput source="companyName" validate={[required()]}/>
      <BooleanInput source="isActive"/>
      <TextInput source="comments"/>
      <Typography variant="h6" gutterBottom>Address</Typography>
      <TextInput source="address.country" label="Country" />
      <TextInput source="address.region" label="Region" />
      <TextInput source="address.street" label="Street" />
      <TextInput source="address.houseNumber" label="House"/>
      <TextInput source="address.postalCode" label="Postal Code"/>
      <Typography variant="h6" gutterBottom>Credits and Sessions</Typography>
      <NumberInput
        source="maxConcurrentSessions"
        validate={[required(), number(), minValue(1), maxValue(10), integerValidation]}
        initialValue="5"
        step="1"
        
      />
      <TextField source="creditsPerMonth"/>
      <FunctionField
        source="creditsPerMonth"
        label="Credits Left This Month"
        render={(record: any) => {
          return record.creditsPerMonth + record.additionalCreditsForThisMonth - record.usedCreditsThisMonth
        }}/>
      <NumberInput source="updatedCreditsForNextMonth"/>
      <NumberInput source="additionalCreditsForThisMonth"/>
    </SimpleForm>
  </Edit>
);

const CustomerFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn variant="outlined"/>
    <TextInput source="companyName" variant="outlined"/>
    <NullableBooleanInput source="isActive" variant="outlined"/>
    <TextInput source="comments" label="Template Edition" variant="outlined"/>
    <TextInput source="country" variant="outlined"/>
    <NumberInput source="maxConcurrentSessions" label="Max Sessions" variant="outlined"/>
    <NumberInput source="creditsPerMonth" variant="outlined"/>
    <NumberInput source="additionalCreditsForThisMonth" label="Additional Credits" variant="outlined"/>
  </Filter>
);